import bike from '~/assets/icons/bike.svg';
import boat from '~/assets/icons/boat.svg';
import bus from '~/assets/icons/bus.svg';
import car from '~/assets/icons/car.svg';
import plane from '~/assets/icons/plane.svg';
import truck from '~/assets/icons/truck.svg';
import { CharacterLicense } from '~/shared';

export const licenseIcons = {
	[CharacterLicense.DrivingBike]: bike,
	[CharacterLicense.DrivingCar]: car,
	[CharacterLicense.DrivingTruck]: truck,
	[CharacterLicense.Flying]: plane,
	[CharacterLicense.Sailing]: boat,
	[CharacterLicense.DrivingBus]: bus,
};

export interface ICategoryProps {
	name: string;
	type: string;
	price: number;
	icon: string;
	selected?: boolean;
	notActive?: boolean;
}
